export const addLayer = (data, mapLayers, openAddLayer) => {
  let mCopy = JSON.parse(JSON.stringify(mapLayers));
  let newLayer = JSON.parse(JSON.stringify(data));
  newLayer.active = true;

  let listIndex = openAddLayer.listIndex;

  if (listIndex.length === 1) {
    let i1 = listIndex[0];
    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerSettings.push(newLayer);
  } else if (listIndex.length === 2) {
    let i1 = listIndex[0];
    let i2 = listIndex[1];
    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerSettings.push(newLayer);
  } else if (listIndex.length === 3) {
    let i1 = listIndex[0];
    let i2 = listIndex[1];
    let i3 = listIndex[2];
    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerCategories[
      i3
    ].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerCategories[
      i3
    ].layerSettings.push(newLayer);
  }

  return JSON.parse(JSON.stringify(mCopy));
};
